export const tr = {
  ADD_COLOR_STRING_KEY: 'Renk ekle',
  ADD_TEXT_KEY: 'Metin Ekle',
  ADD_TO_ORDER_KEY: 'Sipariş ekle',
  ADD_TO_CART: 'Sepete Ekle',
  ADD_TEMPLATE: 'Şablon ekle',
  ADJUST_SIZE_KEY: 'Boyutu ayarla',
  ADJUST_TRANSPARENCY_KEY: 'Şeffaflık Ayarı',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Alt Hizala',
  ALIGN_CENTER_KEY: 'Merkezi hizalama',
  ALIGN_KEY: 'hizalamak',
  ALIGN_LEFT_KEY: 'Sola hizalamak',
  ALIGN_MIDDLE_KEY: 'ortaya hizala',
  ALIGN_RIGHT_KEY: 'Sağa hizala',
  ALIGN_TOP_KEY: 'Üst Hizala',
  ALL_TAB_TITLE_KEY: 'Tümü',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Uygula',
  AREA_CODE: 'Area code',

  BASIC_HELPER_INSTRUCTION1_KEY:
    'İçeriklere göz atın ve tasarımınız için görsel seçin veya kendi görsellerinizi yükleyin.',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Tasarımınızın önizlemesini kontrol edin veya ince ayar yapın.',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Tasarımınızı düzenleyin ve projenize yeni elementler ekleyin.',
  BASIC_HELPER_INSTRUCTION4_KEY:
    "Tasarımınız hazır olduğunda, İLERİ'ye tıklayın ve sipariş vermeden önce son kontrollerinizi yapın.",
  BACK_KEY: 'Geri',
  BACKGROUND_KEY: 'Arkaplan',
  BACKGROUND_UPPER_CASE_KEY: 'Zemin',
  BACKGROUND_CONTRAST_KEY: 'Zemin contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'Bu kategoride ilham kaynağı bulunamadı',
  BRING_TO_FRONT_KEY: 'Öne Getir',
  CANCEL_TEXT_KEY: ' İptal ',
  CENTIMETERS_KEY: 'santimetre',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Proje ayarlarını değiştir',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Bilgisayardan seç',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Dosya Seç',
  CITY: 'Şehir',
  CLEAR_ALL_KEY: 'Tümünü Temizle',
  CLEAR_COLOR_KEY: 'Rengi Temizle',
  CLOSE_WINDOW_KEY: 'Pencereyi kapat',
  CLEAR_ALL_OBJECTS: 'Tüm nesneleri temizle',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Bu, arkaplanınızdaki tüm nesneleri kaldırır.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Renk',
  CONTINUE_KEY: 'Devam...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Ülke',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Özel',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Tasarım',
  DELETE_KEY: 'Sil',
  DOCUMENT_COLORS: 'Belge renkleri',
  DONE: 'Bitti!',
  DONE_KEY: 'Bitti',
  DONT_SHOW_ALERT_KEY: 'Tekrar gösterme',
  DOWNLOAD_COLUMN_HEADER_KEY: 'İndir',
  DOWNLOAD_APP_TITLE_KEY: 'Uygulamayı buradan indirebilirsiniz:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox İçe Aktarım',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    "Görselin boyutu 1 GB'tan az ve pdf, png, jpg, svg veya tiff formatlarından birinde olmalıdır.",
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime araması',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime görüntüleri',
  DUPLICATE_KEY: 'Çoğalt',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Tasarımı Düzenle',
  EDIT_LOWERCASE_KEY: 'Düzenle',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Üzgünüz, bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Hay aksi, yüklenen PDF dosyasını açarken sorun oluştu.',
  EMAIL_KEY: 'E-posta',
  EMAIL_ADDRESS_KEY: 'E-posta Adresi:',
  EMAIL_CHECKBOX_MESSAGE:
    "Bu kişinin HP'den benim adıma veya bu hizmet sağlayıcısı adına e-posta alacağını anladığını biliyorum.",
  EXTRA_INFO_KEY: 'Ekstra bilgi',
  EMAIL_NOTIFICATION:
    'Kısa bir süre içinde bir e-posta gönderilecek. Lütfen 15 dakika kadar işlemi bitmesini bekleyin.',
  EMAIL_DIALOG_MESSAGE:
    'Tasarımınızı paylaşmak istediğiniz kişinin e-posta adresini girin.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Mevcut Klasör',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Ödemeye geçmeden önce seçilen tüm öğelerin doğru olduğundan emin olun',
  FINAL_CHECK_TITLE_KEY: 'Son Kontrol',
  FINISH_KEY: 'Son',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Çevir',
  FOR_KEY: 'için',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Anahtar Sözcükler:',
  FOLDER_NAME: 'Klasör Adı',
  FOLDER_NAME_KEY: 'Klasör Adı:',
  FOLDER_ALREADY_EXIST_KEY: 'Bu adda bir klasör zaten var',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Anladım',
  GROUP_ALL_KEY: 'Tümünü Grupla',
  GROUP_SCALE: 'Grup Ölçeği',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Projenizi adlandırın',
  HEIGHT_KEY: 'Yükseklik',
  HELP_KEY: 'Yardım',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'GÖRÜNTÜLER',
  IMPERIAL_KEY: 'Ölçü',
  IMPORTING_KEY: 'İçe aktarılıyor',
  INCHES_COLUMN_HEADER_KEY: 'İnç',
  INCHES_KEY: ' inç',
  INCHES_UNIT_STRING_KEY: 'inç',
  INVALID_EMAIL_ADDRESS_KEY: 'Geçersiz E-Posta Adresi',
  INVALID_INFO_KEY: 'Lütfen detayları giriniz.',
  INVALID_NAME_KEY: 'Geçersiz Ad',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    "Üzgünüz, seçtiğiniz dosya çok büyük. Maksimum dosya boyutu 500mb'dır.",
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Hay aksi, bu geçerli bir dosya biçimi değil. Yalnızca pdf, jpg, png, svg ve tif dosyalarını işleyebiliyoruz.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Dil',
  LASTNAME: 'Soyad',
  LEARN_MORE: 'Daha Fazlasını Öğrenin',
  LEARN_THE_BASICS_KEY: 'Temel prensipleri öğrenin.',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Bu siteyi kullanarak, bunlara uyacağınızı kabul etmiş olursunuz',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Bu web sitesi, şunlarla uyumludur',
  LEGAL_FOOTER_MESSAGE3_KEY: 've de',
  LENGTH_STRING_IN_INCHES_KEY: 'inç',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Eklediğiniz içeriği görüntülemek için lütfen LinkReader uygulamasını indirin.',
  LOADING_KEY: 'Yükleniyor...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Kilitle',
  LOGIN_KEY: 'Oturum aç',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: "Dreamstime'a Giriş Yapın",
  LOGOUT_KEY: 'Oturumu Kapat',
  MATERIAL_TITLE_KEY: 'MALZEME',
  MATERIAL_STRING_KEY: 'Malzeme',
  MEASUREMENT_KEY: 'Ölçü',
  METRIC_KEY: 'Ölçü',
  MINIMUM_ZOOM_WARNING:
    'Duvarınızı kaplamak için gereken minimum yükseklik veya genişliğe ulaştığınız için bu arkaplan daha fazla ölçeklendirilemez.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Model',
  MORE_INFO_TEXT_KEY: 'Daha fazla bilgi',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  NAME_KEY: 'Ad:',
  NEXT_BUTTON_TITLE_KEY: 'İLERİ',
  NEW_FOLDER_KEY: 'Yeni Klasör',
  NO_SHADOW_KEY: 'Gölge Yok',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'Objeler',
  OK_KEY: 'Tamam',
  ORDER_SAMPLE_KEY: 'Örnek Sipariş Et',
  ORDER_SAMPLE: 'Örnek sipariş edin',
  ORDER_SAMPLE_INFOLABEL_1:
    'Sipariş vermek istediğiniz görüntünün bir bölümünü örnek olarak seçin',
  ORDER_SAMPLE_INFOLABEL_2:
    'Projenizin gerçek boyutlu yakından bir görüntüsünün bulunduğu bir e-posta alacaksınız',
  ORDER_SAMPLE_INFOLABEL_3:
    'Bu e-posta, görüntünün kalitesini ve çözünürlüğünü değerlendirmenize yardımcı olacaktır',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Hemen Örnek Sipariş Et',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Kalitesini/çözünürlüğünü kontrol etmek için projenizin gerçek boyutlardaki bir yakın görünümünü içeren bir e-posta alacaksınız.',
  ORIENTATION_KEY: 'Yön',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Parola',
  PATTERN_COLOR_KEY: 'Model rengi',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'Fotoğraflar',
  PHOTO: 'Fotoğraf',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Bu resmin telif haklarına sahibim ve kabul ediyorum:',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    "Görselin boyutu 500 MB'tan az ve png, jpg, tiff, svg veya pdf formatlarından birinde olmalıdır.",
  PIXEL_COLUMN_HEADER_KEY: 'Piksel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Metni buraya ekle',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'Örneğin, basımevine iletmek istediğiniz önemli bazı şeyler',
  PLACEHOLDER_INCHES_STRING_KEY: 'inç',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Pozisyon',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Projenizi kaydedin',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Projenizde, devam etmeden önce kaydedilmesi gereken değişiklikler var.',
  PRICE_COLUMN_HEADER_KEY: 'Fiyat',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'İşleniyor...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Önizle',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Proje Adı',
  PROJECT_NAME: 'Proje Adı:',
  PROJECT_ALREADY_EXIST_KEY: 'Bu adda bir proje zaten var',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Bu adda bir proje zaten var',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Bu adda bir klasör zaten var',
  PIXELATION_WARNING_KEY: 'Pikselleşme Uyarısı',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Yüklediğiniz fotoğrafın çözünürlüğü nedeniyle cildiniz bozulabilir veya bozulabilir. Bulanıklık olmaması için lütfen kaliteli bir resim yükleyin ve resmin uzamasından kaçının. Önizlemeden memnunsanız ve devam etmek istiyorsanız, lütfen göndermeye devam edin.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'GEREKLİ',
  RECOLOR_KEY: 'Yeniden Renklendirin',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Yeniden Renklendirin',
  REQUEST_SAMPLE_KEY: 'Bir örnek talep et',
  RESIZE_KEY: 'Yeniden boyutlandır',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Gözden geçir ve gönder',
  REQUEST_FOR_QUOTATION: 'Teklif Talebi',
  RIGHT_LOGO_TEXT_KEY: '-',
  ROTATE_KEY: 'Döndür',
  ROTATE_LEFT_KEY: '90° Sola Döndür',
  ROTATE_RIGHT_KEY: '90° Sağa Döndür',
  ROTATION_KEY: 'Döndürme',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Satırlar ve Sütunlar',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Kaydet',
  SAVING_KEY: 'Kaydediliyor...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Şablonu kaydet',
  SAVE_DIALOG_TITLE: 'Projenizi kaydedin',
  SAVE_PROJECT_NAME_KEY: 'Önce projenizi kaydedin',
  SAVEDIALOG_MESSAGE:
    'Projenizi kaydetmek için lütfen oturum açın. Hesabınız yoksa, oluşturmanıza yardımcı olacağız. Kaydettiğiniz ilerleme kaybedilmeyecek.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Görseli tasarıma sığdırmak için ölçeklendirin',
  SCALE_KEY: 'Ölçeklendir',
  SCALE_ALL_KEY: 'Tümünü Ölçeklendir',
  SCALE_TO_FILL_KEY: 'Doldurmak İçin Ölçeklendir',
  SEARCH_BUTTON_TITLE_KEY: 'Ara',
  SELECT_CUSTOM_SIZE_KEY: 'Boyut seç',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Ara',
  SELECTED_IMAGE_KEY: ' Seçilen imaj: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Kurulum talimatlarını gönder',
  SEND_TO_BACK_KEY: 'Arkaya Yolla',
  SEND_KEY: 'Gönder',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Boyutu Ayarla',
  SETTINGS_KEY: 'Ayarlar',
  SETTINGS_UPPERCASE_KEY: 'Ayarlar',
  SHARE_KEY: 'Paylaş',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Geç',
  SOLID_COLORS_KEY: 'Düz renkler',
  SQFT_UNIT_STRING_KEY: 'ft. kr.',
  SQM_UNIT_STRING_KEY: 'm. kr.',
  START_TOUR_KEY: 'Turu başlat',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Gönder',
  SHARE_LINK_LABEL: 'Paylaşmak istediğiniz bağlantı türünü seçin',
  SHARE_EDIT_LINK: 'Bağlantı ekle',
  SHARE_VIEW_LINK: 'Bağlantıyı görüntüle',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* Hedef görüntüleme mesafesi, ayarlardan değiştirilebilir.',
  TERMS1_KEY: 'şartlar',
  TERMS2_KEY: 'HP Gizlilik sözleşmesi',
  TERMS3_KEY: 'HP Kişisel Verilere İlişkin Haklar Bildirimi',
  TERMS_OF_USE_KEY: 'Kullanım Şartları',
  TERMS_OF_USE: 'Kullanım Şartları.',
  TEXT_ANCHOR_MIDDLE: 'Ortala',
  TEXT_SHADOW_COLOR_KEY: 'Metin gölge rengi',
  TEXT_UPPERCASE_KEY: 'Metin',
  TILE_KEY: 'Döşeme',
  TOTAL_KEY: 'TOPLAM',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Şeffaflık',
  TEMPLATES_KEY: 'Şablonlar',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Teşekkür Ederiz',
  TOUR_DESCRIPTION_TEXT:
    'Tasarım sürecini izleyin. Bu yardım turunu daha sonra tekrar izlemek için Yardım ikonuna tıklayın.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Kilidi Aç',
  UNGROUP_KEY: 'Grubu Çöz',
  UPDATE_TEXT_KEY: 'Güncelleştirme',
  UPLOAD_KEY: 'Resim Yükleme',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Kendi görselinizi yükleyin.',
  UPLOAD_UPPERCASE_KEY: 'Yükle',
  USER_NAME: 'Kullanıcı Adı',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Döşemeyi Kaldır',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Geçerlilik',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'KDV',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: "Fotolia©'da Görüntüle",
  VIEW_GETTY_IMAGE_KEY: "Getty Image©'da Görüntüle",
  VIEW_I_STOCK_KEY: "iStock©'da Görüntüle",
  VIEW_DESIGN_DETAILS_KEY: 'Tasarım ayrıntılarını görüntüleyin',
  VIEW_DESIGNER_PROFILE_KEY: 'Tasarımcı profilini görüntüleyin',
  VIEW_PRICE_KEY: 'Fiyatı Görüntüle',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Duvar Posteri',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Uyarı',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Genişlik',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Adınız',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Projeniz:',
  PROJECT_NAME_ERROR_TEXT: 'Lütfen projeniz için bir ad girin.',
  PROJECT_FOLDER_ERROR_TEXT: 'Lütfen proje klasörünüz için bir ad girin.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel ayarları',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minimum görüntüleme mesafesi',
  BACKGROUND_UPLOAD_KEY: ' Zemin ',
  OBJECT_UPLOAD_KEY: ' Obje ',
  PHOTO_UPLOAD_KEY: ' Fotoğraf ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Hiçbir dreamstime İçeriği bulunamadı',
  NO_ELEMENT_ERROR_MESSAGE: 'Hiç öğe bulunamadı.',
  NO_MORE_IMAGES_FOUND_KEY: 'Başka resim bulunamadı',
  NO_PATTERN_ERROR_MESSAGE: 'Desen bulunamadı.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: "{0}'e değiştir.",
  DOWNLOADS_KEY: '{0} İndirme',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Yakın',
  FAR_KEY: 'Uzak',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'Kullanmak istediğiniz görseller, tasarım alanından daha küçük veya daha büyük.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'Daha iyi çözünürlük için 999-çözünürlük ayarı kullanın',
  MESSAGE_KEY: 'Mesaj:',
  VIEWS_KEY: '{0} İzlenme',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Basılı resminizi, {0} {1} * (geçerli basılı çözünürlük {2} dpi değeridir) mesafede görüntülerken pikselli görünebilecek şekilde ölçeklendirdiniz.',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Önerilen görüntüleme mesafesi {0} {1} olacaktır. Bu uygun değilse, lütfen bu resmin ölçeğini veya Duvar Çiziminizin boyutunu düşürün.',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_LAPTOP_TEXT:
    'The recommended viewing distance would be {0} {1} If this is not appropriate, please decrease the scale of this image.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Önerilen asgari resim boyutu {0} x {1} piksel olmalıdır.',
  UPLOAD_STATUS: '{0}% / {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Minimum boyutlar: {0} (g) x {1} (y).',
  MINIMUM_HEIGHT_KEY: 'Minimum yükseklik: {0}.',
  MINIMUM_WIDTH_KEY: 'Minimum genişlik: {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'Maksimum genişlik: {0}',
  MAXIMUM_HEIGHT_KEY: 'Maksimum yükseklik: {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Lütfen sıfırdan büyük sayısal boyutlar girin.',
  PROCESSING_FAILED:
    'İşleme başarısız oldu, lütfen bir süre sonra tekrar deneyin',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Üzgünüz, çok sayfalı PDF dosyaları desteklenmemektedir.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    "Maalesef, şifrelenmiş PDF'ler desteklenmiyor.",
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Dosya içe aktarılıyor: {0} / {1}',
  RECOLORING_KEY: 'Yeniden Renklendiriliyor...',
  TEXT_COLOR_KEY: 'Metin rengi',
  SOLID_COLOR_KEY: 'Düz renkler',
  AUTHENTICATE_DIALOG_TITLE: 'Bu içerik kaynağı parola korumalı',
  AUTHENTICATE_FAILED_MESSAGE: 'Kimlik doğrulaması başarısız!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Bazı dosyaların içe aktarılması sırasında sorun oluştu',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',

  DEFAULT_PROJECT_NAME: 'Project',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  MATERIAL_CHOICE_APPLIED: 'Malzeme seçimi uygulandı.',
  HP_FEEDBACK_TEXT: 'HP Görüşünüze Önem Veriyor',
  FEEDBACK_QUERY_TEXT: 'Genel olarak uygulamamızdan ne kadar memnun kaldınız?',
  VERY_SATISFIED_BUTTON_TEXT: 'Çok memnunum',
  SATISFIED_BUTTON_TEXT: 'Memnunum',
  DISSATISFIED_BUTTON_TEXT: 'Memnun değilim',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Hiç memnun değilim',
  FEEDBACK_PERMISSION_STRING_KEY:
    "HP'ye geri bildirimim hakkında benimle iletişime geçmesi için izin veriyorum",
  FEEDBACK_IMPROVE_TEXT: 'Geliştirme önerilerinizi paylaşır mısınız?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Paylaş',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Bu İlham şablonunun varsayılan boyutu {0} X {1} {2} ile gelir. Sayfa boyutunuz bu şablona uyacak şekilde otomatik olarak değiştirilecektir.',
  FEEDBACK_PLACEHOLDER_TEXT:
    'Ürünlerimizi geliştirmek için görüşlerinizi gözden geçiririz, bu nedenle lütfen kişisel verilerinizi veya gizli / özel içeriklerinizi paylaşmayın.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: "Laptop'ını seç",
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Ad',
  LAST_NAME_KEY: 'Soyad',
  PHONE_NUMBER_KEY: 'Telefon numarası',
  POSTAL_ADDRESS: 'Teslimat Adresi',
  COMPANY_NAME: 'Firma Adı',
  INVALID_PHONE_NUMBER_KEY: 'Geçersiz telefon numarası',
  INVALID_POSTAL_ADDRESS: 'Geçersiz Teslimat Adresi',
  INVALID_COMPANY_NAME: 'Geçersiz Firma Adı',
  TERMS_AND_CONDITIONS: 'Kampanya koşulları okudum kabul ediyorum.',
  INVOICE_UPLOAD: 'Faturanızı Yükleyin',
  INVOICE_FILE_MISSING: 'fatura dosyası eksik',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Gelecekteki HP kampanyaları ile ilgili kişisel bilgilerimin HP ile paylaşılmasını ve e-posta yolu ile iletişime geçilmesini kabul ediyorum.*',
  SERVICE_PROVIDER_CONDITION:
    'Sağladığım verilerin, baskı ve teslimat süreçlerinin yürütülebilmesi amacıyla servis sağlayıcılara aktarılabileceğini kabul ediyorum.',
  ORDER_DESIGN: 'Tasarım siparişini ilet',
  SUBMIT_YOUR_DESIGN: 'Tasarımınızı gönderin',
  SUBMISSION_DESIGN_ORDER: 'Tasarım Baskı Talebi',
  ENTER_REQUIRED_FIELDS_KEY: 'Lütfen zorunlu alanları giriniz',
  ADDRESS_KEY: 'Adres',
  INVALID_ADDRESS_KEY: 'Geçersiz adres',
  CITY_KEY: 'Şehir',
  INVALID_CITY_KEY: 'Geçersiz şehir',
  COUNTRY_KEY: 'Ülke',
  STATE_KEY: 'Belirtmek',
  ZIP_KEY: 'Posta kodu',
  INVALID_ZIP_KEY: 'Geçersiz posta kodu',
  ORDER_NUMBER: 'Sipariş numarası',
  YOUR_DETAILS_KEY: 'Detayların',
  APPLY_DESIGN_COMPETITION: 'Tasarım Yarışması Başvurusu',
  NOTICE_KEY: 'Farkına varmak:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Bir PC kaplamasının sizinkine mükemmel şekilde uyarlanması için, faturada görüldüğü gibi satın alma işlemine karşılık gelen tam modeli seçmelisiniz.',
  RESTART_PROJECT_ALERT_TITLE: 'Proje yeniden başlatılsın mı?',
  DISCARD_ALERT_MESSAGE: 'Projeniz iptal edilecek.',
  RESTART: 'Yeniden başlat.',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'sertifikası',
  AUTHENTICITY_STRING: 'otantiklik',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Sayfa Boyutu Uyarısı!',
  MODIFY_SIZE_WARNING:
    'Bu tasarımı yeniden boyutlandırmak isterseniz, bunu “Ayarlar” sekmesinden yapabilirsiniz. Tasarım öğeleri, istediğiniz boyutlara ayarlamak için düzenleme gerektirebilir.',
  RANDOMIZE_KEY: 'Rastgele',
  PLEASE_WAIT: 'lütfen bekle',
  PROTECTING_YOUR_DATA: 'verilerinizi korumak...',
  SEARCH_YOUR_LAPTOP_KEY: 'Dizüstü bilgisayarınızda arama yapın', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Hata! Aramanız için hiçbir dizüstü bilgisayar bulamadık.', // Google translated
  SERIAL_NUMBER_KEY: 'Seri numarası',
  LOCKED_PROJECT: 'Kilitli Proje',
  LOCKED_MESSAGE:
    'Bu projenin siparişi verildi ve değiştirilemez. Bu projeyi yalnızca görüntüleyebilirsiniz. ',
  EXPIRED_PROJECT: 'Süresi Dolmuş Proje',
  EXPIRED_MESSAGE: 'Bu projenin süresi dolmuş.',
  DELETED_PROJECT: 'Silinen Proje',
  DELETED_MESSAGE: 'Bu proje silinmiş.',
  CHOOSE_GROUP_TYPE: '{0} türünü seç',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Lütfen sıfırdan büyük sayılar girin.',
  SIZE_KEY: 'Boyut',
  DISTANCE_FROM_KEY: 'Mesafe',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Sol',
  RIGHT_KEY: 'Sağ',
  DELETE_WALL_KEY: 'Delete a wall',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Maksimum duvar boyutu: {0} kr.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'Tuval yüksekliği duvar yüksekliğini geçiyor.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Tuval genişliği duvar genişliğini geçiyor.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Geçerli genişlik için maksimum sütun sayısı: {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Geçerli yükseklik için maksimum satır sayısı: {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Duvar genişliği tuval genişliğinden küçük.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Duvarın minimum genişliği {0} {1} olmalıdır.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Duvarın minimum yüksekliği {0} {1} olmalıdır.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Duvar yüksekliği tuval yüksekliğinden küçük.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maksimum duvar yüksekliği: {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Sütunlar',
  COLUMNS_KEY: 'Satırlar',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Düzenle',
  TOP_KEY: 'Üst',
  BOTTOM_KEY: 'Alt'
};
